import script from "./SogButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogButton.vue?vue&type=script&setup=true&lang=ts"

import "./SogButton.vue?vue&type=style&index=0&id=c4d0d0b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4d0d0b4"]])

export default __exports__